<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMyComplainList"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">售后列表</span>
						<span style="margin-left:20px;">会员类别:</span>
						<RadioGroup v-model="userType"
						    style="margin-left:4px;"
						    @on-change="onUserTypeChage">
						    <Radio label="F"> <span>外部会员</span></Radio>
						    <Radio label="E"> <span>内部会员</span></Radio>
						</RadioGroup>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                        <Button type="info"
                            size='small'
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            @click="onExport()">导出</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMyComplainList" />
                </Col>
            </Row>
        </Card>

        <Modal v-model="complainInfo.show"
            title="售后详情"
            :width="700">
            <Spin size="large"
                fix
                v-if="innerSpin"></Spin>
            <div>   
                <Form :label-width="90" ref="salesDetailForm" :model="complainInfo"  :rules="complainInfoRuleValidate">
                    <Row :gutter="16">
                        <Col span="12">
                        <FormItem label="发货单号:">
                            <Input readonly
                                :value="complainInfo.complainOrderCode"></Input>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="售后类型:">
                            <Input readonly
                                :value="COMPLAIN_TYPE[complainInfo.complainType]"></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                        <FormItem label="详细描述:">
                            <Input readonly
                                :value="complainInfo.complainInfo"
                                type="textarea"
                                :rows="4"></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                        <FormItem 
                            label="回复内容:"  prop="complainResponse">
                            <Input v-model="complainInfo.complainResponse"
                                type="textarea"
                                :rows="4"></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="11">
                        <FormItem requied
                            label="回复结果:">
                            <RadioGroup v-model="complainInfo.complainResult">
                                <Radio :label="COMPLAIN_RESULT_COMPENSATE">
                                </Radio>
                                <Radio :label="COMPLAIN_RESULT_NO_COMPENSATE">
                                </Radio>
                            </RadioGroup>
                        </FormItem>
                        </Col>
						<Col span="3" v-if="$checkAccessArray(['G'])&&complainInfo.complainResult=='有责，赔付'&&complainInfo.complainCompensationCode==''">
							<Button class="btns" type="primary" @click="onCompesationCreate">新增退款单</Button>
						</Col>
						<Col span="10" v-if="complainInfo.complainResult=='有责，退款'">
						<FormItem label="退款单号:">
						    <Input v-model="complainInfo.complainCompensationCode"></Input>
						</FormItem>
						</Col>
                    </Row>
                </Form>

            </div>
            <div slot="footer">
                <Button type="success" @click="onSaveComplain()">保存</Button>
            </div>
        </Modal>

        <Modal v-model="compenstationModal.show"
            title="新增退款单"
            class-name="vertical-center-modal"
              @on-cancel="onCompensationcancel"
            width="800">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Form label-position="top"
				ref="compenstationModal"
				:model="compenstationModal"
				:rules="ruleValidate">
                <Row :gutter="16">
                    <Col span="8">
                    <FormItem label="发货单号">
                        <Input readonly v-model="compenstationModal.compensationRecordRelateRecordCode"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="客户名称">
                        <Input readonly
                            v-model="compenstationModal.userPersonName"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="定单金额">
                        <Input readonly
                            v-model="compenstationModal.totalOrderCost"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="退款原因" prop="compensationRecordType">
                        <Select v-model="compenstationModal.compensationRecordType">
                            <Option v-for="item in COMPENSATION_TYPE_OPTIONS"
                                :key="item.value"
                                :value="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="退款方">
						<Input readonly
						    value="苗场"></Input>
                       <!-- <Select v-model="compenstationModal.compensationRecordPayerType">
                            <Option v-for="item in COMPENSATION_PERSON_OPTIONS"
                                :key="item.value"
                                :value="item.value">{{ item.label }}</Option>
                        </Select> -->
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="被退款方">
						<Input readonly
						    value="客户"></Input>
                        <!-- <Select v-model="compenstationModal.compensationRecordPayeeType">
                            <Option v-for="item in COMPENSATION_PERSON_OPTIONS"
                                :key="item.value"
                                :value="item.value">{{ item.label }}</Option>
                        </Select> -->
                    </FormItem>
                    </Col>
                </Row>
				<Row>
					<Col span="12">
					<FormItem label="凭证" prop="voucherFile">
						<FileUpload :key="timer" v-model="compenstationModal.voucherFile" :mode="mode"></FileUpload>
					</FormItem>
					</Col>
				</Row>
            </Form>
            <Row :gutter="16">
                <Col span="24">
                <Table size="small"
                    :columns="productTable.columns"
                    :data="productTable.data"
                    :loading="productTable.loading"
                    highlight-row
                    stripe
                    border />
                </Col>
            </Row>
            <div slot="footer">
                <span style="color:red;font-size:20px;margin-right:40px;">共计赔付:{{numberToFixed(compenstationModal.totalValue,4)}}</span>
                <Button type="primary"
                    @click="onCompensationSave">确认</Button>
                <Button type="error"
                    @click="onCompensationcancel">取消</Button>
            </div>
        </Modal>

        <PreSaleDeliveryDetail ref="preSaleDeliveryDetailModal" />
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import { dateTimeRender } from "@/libs/tableRowTimeRender";
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
import { numberToFixed } from '@/components/number-input/display-format';
import { COMPLAIN_TYPE, COMPLAIN_RESULT_COMPENSATE, COMPLAIN_RESULT_NO_COMPENSATE } from './complain-type';
import { getComplainList, responseComplain } from "@/api/modules/sale-management/sale-approve";
import PreSaleDeliveryDetail from '../../preSale-management/preSale-delivery/preSale-delivery-detail.vue';
import { getCompensationList, saveCompensation, getSaleOrderDetailByCode } from "@/api/modules/sale-management/sale-approve";
import { COMPENSATION_TYPE_OPTIONS, COMPENSATION_PERSON_OPTIONS } from '../compensation/compensation-type';
import { DOWNLOAD_SERVER, FILE_SERVER, UPLOAD_FILE_API } from '@/api/modules/files';
import SingleFileUploadWithName from '@/components/single-file-upload-with-name/SingleFileUploadWithName';
import FileUpload from "@/components/file-upload/file-upload-multi";
export default {
    name: "CompensationList",
    components: {
        FileUpload,
        StandPaginationTable,
        SearchCard,
        PreSaleDeliveryDetail,
        SingleFileUploadWithName,
        DecimalInput
    },
    data() {
        return {
            timer:'',
            mode: 'add',
            userType:'F',
            innerSpin: false,
            COMPLAIN_TYPE,
            COMPLAIN_RESULT_NO_COMPENSATE,
            COMPLAIN_RESULT_COMPENSATE,
            COMPENSATION_TYPE_OPTIONS,
            COMPENSATION_PERSON_OPTIONS,
            mainTable: {
                columns: [
                    { type: "index", width: 60, align: "center" },
                    { title: "客户账号", key: "customerName", align: "center" },
                    { title: "客户名称", key: "customerPersonName", align: "center" },
                    {
                        title: '发货单号', key: 'complainOrderCode', width: 180, align: 'center',
                        render: (h, params) => {
                            return h('a', {
                                on: {
                                    click: () => {
                                        this.$refs.preSaleDeliveryDetailModal.showModal(params.row.complainOrderUuid);
                                    }
                                }
                            }, params.row.complainOrderCode);
                        }
                    },
                    { title: "苗场", key: "seedFarmName", align: "center" },
                    { title: "客户经理", key: "managerPersonName", align: "center" },
                    {
                        title: "发起时间",
                        key: "complainSendTime",
                        width: 120,
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(h, params.row.complainSendTime)
                    },
                    { title: "回复状态", key: "complainReponseStatus", align: "center" },
                    { title: "回复结果", key: "complainResult", align: "center" },
                    {
                        title: "回复时间",
                        key: "complainResponseTime",
                        width: 120,
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(h, params.row.complainResponseTime)
                    },
                    { title: "回复人", key: "complainResponsePerson", align: "center" },
                    {
                        title: '操作',
                        key: 'withDrawAction',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.$refs.salesDetailForm.resetFields();
                                            Object.assign(this.complainInfo, params.row);
                                            this.compenstationModal.compensationRecordRelateRecordCode = this.complainInfo.complainOrderCode;
                                            this.complainInfo.show = true;
                                            
                                        }
                                    }
                                }, '查看')]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: "客户信息", type: "Input", value: "", name: "concat(customer.userName, customer.userPersonName)", sql: "like" },
                    { label: "关联单号", type: "Input", value: "", name: "complainOrderCode", sql: "like" },
                    { label: '发起时间', type: 'Daterange', value: '', name: 'complainSendTime', sql: 'dateBetween' },
                    { label: "苗场", type: "Input", value: "", name: "concat(seedFarmCode, seedFarmName)", sql: "like" },
                    { label: "客户经理", type: "Input", value: "", name: "concat(manager.userName,  manager.userPersonName)", sql: "like" },
                    { label: '回复状态', type: 'Select', name: 'complainReponseStatus', sql: 'in', options: [{ value: '未回复', key: '未回复' }, { value: '已回复', key: '已回复' }] },
					 { label: '回复结果', type: 'Select', name: 'complainResult', sql: 'in', options: [{ value: '有责，赔付', key: '有责，赔付' }, { value: '无责，无需赔付', key: '无责，无需赔付' }] }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            complainInfo: {
                show: false,
                complainUuid: '',
                complainResponse: '',
                complainResult: '',
                complainCompensationCode: '',
                complainOrderCode: ''
            },
            compenstationModal: {
                show: false,
                compensationRecordRelateRecordCode: '',
                compensationRecordPayerType: '',
                compensationRecordPayeeType: '',
                compensationRecordUuid: '',
                compensationRecordCode: '',
                compensationRecordRelateRecordUuid: '',
                userPersonName: '',
                totalOrderCost: 0,
                compensationRecordType: '',
                compensationDetailModels: [],
                totalValue: 0,
                voucherFile:''
            },
            ruleValidate:{
                compensationRecordType:[
                    { required: true, message: '请选择退款原因', trigger: 'blur' }
                ],
                voucherFile:[
                    { required: true, message: '凭证不能为空', trigger: 'blur' }
                ]
            },
            complainInfoRuleValidate:{
                complainResponse: [	{ required: true, message: '回复内容原因', trigger: 'blur' }]
            },
            productTable: {
                columns: [
                    { title: "编号", key: "productCode", align: "center" },
                    { title: "品名", key: "productName", align: "center" },
                    { title: "批次", key: "productBatchCode", align: "center" },
                    { title: "定单价格", key: "productPrice", align: "center" },
                    { title: "定单数量", key: "productQuantity", align: "center" },
                    {
                        title: "赔付价格", key: "compensationDetailProductPrice", align: "center",
                        render: (h, params) => {
                            return h(DecimalInput, {
                                props: {
                                    value: params.row.compensationDetailProductPrice,
                                    precision: 4,
                                    max: this.productTable.data[params.index].productPrice
                                },
                                on: {
                                    change: newVal => {
                                        this.productTable.data[params.index].compensationDetailProductPrice = newVal;
                                        this.productTable.data[params.index].compensationDetailProductValue = this.productTable.data[params.index].compensationDetailProductPrice * this.productTable.data[params.index].compensationDetailProductCount;
                                        this.calculateTotalValue();
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: "赔付数量", key: "compensationDetailProductCount", align: "center",
                        render: (h, params) => {
                            return h(IntegerInput, {
                                props: {
                                    value: params.row.compensationDetailProductCount,
                                    max: this.productTable.data[params.index].productQuantity
                                },
                                on: {
                                    change: newVal => {
                                        this.productTable.data[params.index].compensationDetailProductCount = newVal;
                                        this.productTable.data[params.index].compensationDetailProductValue = this.productTable.data[params.index].compensationDetailProductPrice * this.productTable.data[params.index].compensationDetailProductCount;
                                        this.calculateTotalValue();
                                    }
                                }
                            });
                        }
                    },
                    { title: "赔付金额", key: "compensationDetailProductValue", align: "center" }],
                data: [],
                loading: false,
                tableSearch: search.getSearchParams()
				
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        numberToFixed,
        init() {
            this.getMyComplainList();
        },
        onUserTypeChage(){
            this.getMyComplainList();
        },
        getMyComplainList(reset = false) {
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
			    search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
			    this.mainTable.tableSearch.filters.enable = true;
			    this.mainTable.tableSearch.filters.conditions.push({
			        name: 'memberType',
			        type: 'eq',
			        value: this.userType
			    });
            }
            this.mainTable.loading = true;
            getComplainList(this.mainTable.tableSearch).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(
                        this.mainTable.tableSearch,
                        res.data.filterRecordCount
                    );
                }
            });
        },
        onSaveComplain() {
            this.$refs.salesDetailForm.validate((valid) => {
                if (!valid) {
                    this.$Message.error('回复内容不能为空!');
                    return;
                }
                this.innerSpin = true;
                
                responseComplain(this.complainInfo).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.complainInfo.show = false;
                        this.getMyComplainList();
                        this.$Modal.success({
                            title: '操作完成'
                        });
                    }
                });
            });
        },
        onCompesationCreate() {
            if(!this.complainInfo.complainResponse){
                this.$Modal.error({ title: '新增退款单之前，回复内容不能为空!', content: '' });
                return;
            }
            this.timer = new Date().getTime();
            this.compenstationModal.compensationRecordPayerType="seedfarm";
            this.compenstationModal.compensationRecordPayeeType="customer";
            this.compenstationModal.show = true;            
            this.onSearchOrder();
        },
        onSearchOrder() {
            this.productTable.loading = true;
            getSaleOrderDetailByCode({ orderCode: this.compenstationModal.compensationRecordRelateRecordCode }).then(res => {
                this.productTable.loading = false;
                if (res.code === 0) {
                    let preSaleDeliveryRecord = res.data.orderDetail.preSaleDeliveryRecord;
                    let preSaleDeliveryDetails = res.data.orderDetail.preSaleDeliveryDetails;
                    this.compenstationModal.userPersonName = preSaleDeliveryRecord.preSaleDeliveryRecordOwnerName;
                    this.compenstationModal.totalOrderCost = preSaleDeliveryRecord.preSaleDeliveryRecordTotalCost;
                    this.compenstationModal.compensationRecordRelateRecordUuid = preSaleDeliveryRecord.preSaleDeliveryRecordUuid;
                    this.productTable.data = preSaleDeliveryDetails;
                   
                    this.productTable.data.forEach(e => {
                        debugger;
                        e.detailUuid = e.preSaleDeliveryDetailUuid;
                        e.productCode = e.productCode;
                        e.productName = e.productName;
                        e.productPrice = e.preSaleDeliveryDetailActProductPrice;
                        e.productQuantity = e.preSaleDeliveryDetailQuantity;
                        e.productUuid = e.preSaleDeliveryDetailRelateProductUuid;
                        let detail = this.compenstationModal.compensationDetailModels.find(d => {
                            return d.compensationDetailProductUuid === e.productUuid;
                        });
                        if (detail) {
                            e.compensationDetailProductPrice = detail.compensationDetailProductPrice;
                            e.compensationDetailProductCount = detail.compensationDetailProductCount;
                            e.compensationDetailProductValue = detail.compensationDetailProductPrice * 1000 * detail.compensationDetailProductCount / 1000;
                        }
                        else {
                            e.compensationDetailProductPrice = e.productPrice;
                            e.compensationDetailProductCount = 0;
                            e.compensationDetailProductValue = 0;
                        }
                    });
                    this.calculateTotalValue();
                }
            });
        },
        onCompensationSave() {
            console.log(this.compenstationModal.compensationDetailModels);
            let productList = this.productTable.data.filter(p => {
                return p.compensationDetailProductCount > 0;
            });
            if(!this.compenstationModal.compensationRecordType){
                this.$Modal.error({ title: '请选择退款原因！', content: '' });
                return;
            }
            if(!this.compenstationModal.voucherFile){
                this.$Modal.error({ title: '请上传凭证，凭证不能为空！', content: '' });
                return;
            }
            if (productList.length === 0) {
                this.$Modal.error({ title: '必须填写商品退款数量', content: '' });
                return;
            }
            if (productList.find(e => {
                return e.compensationDetailProductPrice < 0;
            })) {
                this.$Modal.error({ title: '填写的商品退款金额不能少于0', content: '' });
                return;
            }

            let data = {
                compensationRecordUuid: this.compenstationModal.compensationRecordUuid,
                compensationRecordRelateRecordUuid: this.compenstationModal.compensationRecordRelateRecordUuid,
                compensationRecordType: this.compenstationModal.compensationRecordType,
                compensationRecordPayerType: this.compenstationModal.compensationRecordPayerType,
                compensationRecordPayeeType: this.compenstationModal.compensationRecordPayeeType,
                voucherFile: this.compenstationModal.voucherFile,
                details: productList.map(e => {
                    return {
                        compensationDetailRelateDetailUuid: e.detailUuid,
                        compensationDetailProductUuid: e.productUuid,
                        compensationDetailProductPrice: e.compensationDetailProductPrice,
                        compensationDetailProductCount: e.compensationDetailProductCount
                    };
                })
            };
            data.complainUuid=this.complainInfo.complainUuid;
            this.innerSpin = true;
            saveCompensation(data).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.complainInfo.complainCompensationCode = res.data;
                            this.compenstationModal.show = false;
                            this.onCompensationcancel();
                        }
                    });
                }
            });
        },
        onCompensationcancel(){
            this.compenstationModal.compensationRecordPayerType="seedfarm";
            this.compenstationModal.compensationRecordPayeeType="customer";
            this.compenstationModal.compensationRecordUuid='';
            this.compenstationModal.compensationRecordCode='';
            this.compenstationModal.compensationRecordRelateRecordUuid='';
            this.compenstationModal.userPersonName='';
            this.compenstationModal.totalOrderCost=0;
            this.compenstationModal.compensationRecordType='';
            this.compenstationModal.compensationDetailModels= [];
            this.compenstationModal.totalValue=0;
            this.compenstationModal.voucherFile='';
            this.productTable.data = [];
            this.compenstationModal.show = false;
        },
        calculateTotalValue() {
            this.compenstationModal.totalValue = this.productTable.data.map(e => {
                return e.compensationDetailProductValue;
            }).reduce((total, num) => {
                return total + num;
            });
        },
        onExport() {
            const queryData = Object.assign(this.mainTable.tableSearch, {
                needExport: true
            });
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.loading = true;
            getComplainList(queryData).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    window.open(DOWNLOAD_SERVER + res.data.exportFileName, "_blank");
                }
            }).catch(() => {
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style scoped></style>
